export enum KullaniciTuru {
  Ogrenci = 1,
  Ogretmen = 2,
  Idare = 3,
}

export enum SinavTuru {
  Sinav4 = 4, 
  Sinav6 = 6
}